import {
  Grid as G,
  Typography as T,
  Inputs as I,
  TextWithIcon,
} from '../../../components';

import * as S from './styles';
import { stepTypes } from '../../../constants/data-types';

const StepSection = ({
  sectionItems,
  sectionTitle,
  handleTitleChange,
  handleItemChange,
  handleItemRemove,
  handleItemAdd,
  stepType,
  errors,
  optional = true,
  isResourcesLayout = false,
}) => {
  return (
    <>
      <S.SectionContainer>
        <G.Row>
          <G.Col w={[6, 6, 6]}>
            {stepType === stepTypes.QUESTION && (
              <I.BasicInput
                value={sectionTitle}
                label="Section name"
                handleChange={handleTitleChange}
                error={errors?.title}
              />
            )}
            {stepType === stepTypes.DEFAULT && (
              <>
                <T.H5>{sectionTitle}</T.H5>
                {optional && <S.OptionalTag ml="1">(Optional)</S.OptionalTag>}
              </>
            )}
          </G.Col>
        </G.Row>
        <G.Row>
          {sectionItems.map((item, index) => (
            <G.Col w={[4, 6, 6]} key={index} mt="6">
              <I.InputCMS
                formState={item}
                hideRemove={sectionItems.length === 1}
                handleRemove={() => handleItemRemove(index)}
                handleChange={(input) => handleItemChange(index, input)}
                error={errors?.items && errors.items[index]}
                isResourcesLayout={isResourcesLayout}
              />
            </G.Col>
          ))}
        </G.Row>
        <G.Row mt="4">
          <G.Col w={[4, 4, 4]}>
            <TextWithIcon
              text="Add another item"
              isButton
              mt="4"
              color="neutralMain"
              handleClick={handleItemAdd}
              weight="semi"
              disabled={!sectionItems.every((item) => item.title)}
              iconProps={{
                icon: 'add',
                color: 'primaryMain',
                pointer: true,
              }}
            />
          </G.Col>
        </G.Row>
      </S.SectionContainer>
    </>
  );
};

export default StepSection;
